// Wallets are paused on this platform until the old domains move here (26 Sep 2026).
// Set REACT_APP_WALLET_ENABLED=true in .env and rebuild to switch them back on at cutover.
export const WALLET_ENABLED = process.env.REACT_APP_WALLET_ENABLED === "true";
